import React from "react";
import { BookOpenIcon, CrossIcon, HeartIcon } from "lucide-react";
import { MockupSlot } from "./MockupSlot";
import { PageCrop } from "./PageCrop";
import { SectionHeading } from "./SectionHeading";
import { Daisy } from "./decor/Daisy";
import { parableElements, parablePages, upcomingParablePages } from "../data/landing";
const elementIcons = {
  book: <BookOpenIcon className="h-5 w-5 text-royal" aria-hidden="true" data-id="element-58" data-mp="39hhqalte42lq" />,
  cross: <CrossIcon className="h-5 w-5 fill-tangerine text-tangerine" aria-hidden="true" data-id="element-59" data-mp="2cuwb5a3xe2yg" />,
  heart: <HeartIcon className="h-5 w-5 fill-rosy text-rosy" aria-hidden="true" data-id="element-60" data-mp="2gvq1sb8r5vv1" />
};
export function ContentsSection() {
  return <section id="contenu" className="bg-ivory pb-16 md:pb-24" data-id="element-61" data-mp="2lrwx7a3ivoyq">
      <div className="mx-auto max-w-6xl px-5" data-id="element-62" data-mp="2qlrl6pq5uq3m">
        <SectionHeading title="Découvrez tout ce que contient votre Méga Pack" subtitle="Une collection pensée pour faire de la transmission de la foi un moment simple, joyeux et partagé." data-id="element-63" data-mp="2qmkjr3eyu9ao" />

        <div className="relative mt-12 rounded-[2.25rem] border-[5px] border-tangerine bg-sun-light px-5 py-10 md:mt-16 md:px-12 md:py-14" data-id="element-64" data-mp="1ocsxbtv2p9hr">
          <Daisy className="absolute -left-4 -top-4 w-11" data-id="element-65" data-mp="1kbzcj9cxgat3" />
          <Daisy className="absolute -bottom-4 -right-3 w-9" data-id="element-66" data-mp="1fk7igoukbmy7" />

          <div className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="1fimn4x0fbzza">
            <h3 className="font-display text-[1.75rem] font-extrabold uppercase leading-[1.1] text-royal md:text-[2.5rem]" data-id="element-68" data-mp="1akl8qpdy0ou5">
              <span className="text-tangerine" data-id="element-69" data-mp="15nuqpwikvj63">Plus de 50</span> paraboles chrétiennes
              illustrées
            </h3>
            <p className="mt-4 leading-relaxed text-cocoa md:text-lg" data-id="element-70" data-mp="wlv8j0vtu91k">
              De jolies paraboles mettant en scène des personnages attachants et des situations
              que les enfants peuvent comprendre et retrouver dans leur quotidien.
            </p>
            <ul className="mt-7 flex flex-wrap justify-center gap-3" data-id="element-71" data-mp="2qze4i6a7ljkr">
              {parableElements.map(el => <li key={el.label} className="flex items-center gap-2 rounded-full bg-white px-4 pb-1.5 pt-2 font-display text-base font-bold text-royal-deep ring-2 ring-tangerine/25" data-id="element-72" data-mp="2lyqadbqoommb">
                  {elementIcons[el.icon as keyof typeof elementIcons]}
                  {el.text}
                </li>)}
            </ul>
          </div>

          <ul className="-mx-5 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-3 md:mx-auto md:grid md:max-w-4xl md:grid-cols-3 md:gap-6 md:overflow-visible md:px-0" aria-label="Aperçu de pages réelles du Méga Pack" data-id="element-73" data-mp="311glefpw14bq">
            {parablePages.map(page => <li key={page.x} className="w-[72%] shrink-0 snap-center md:w-auto" data-id="element-74" data-mp="3juc4wgydapyu">
                <div className="overflow-hidden rounded-2xl border-4 border-white shadow-[0_8px_22px_rgba(90,58,34,0.15)]" data-id="element-75" data-mp="3jw5dw2wgdma0">
                  <PageCrop x={page.x} title={page.title} data-id="element-76" data-mp="28evt9d1l8o74" />
                </div>
              </li>)}
            {upcomingParablePages.map(page => <li key={page.title} className="w-[72%] shrink-0 snap-center md:w-auto" data-id="element-77" data-mp="20xqz2xwflaxn">
                <MockupSlot src={page.src} label={page.title} hint="Aperçu bientôt disponible" className="aspect-[224/319] w-full bg-white/70" data-id="element-78" data-mp="1vwa1bb98u4la" />
              </li>)}
          </ul>
          <p className="mt-5 text-center text-sm font-semibold text-cocoa-soft" data-id="element-79" data-mp="1h8gkxocc2y1n">
            Aperçu de pages réelles du Méga Pack
          </p>
        </div>
      </div>
    </section>;
}